import { createStore, compose } from 'redux';
import rootReducer from './reducers';
import { persistStore, persistReducer } from 'redux-persist';
import storageLocal from 'redux-persist/lib/storage/session';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  : compose;

const enhancers = composeEnhancers();
const persistConfig = {
  key: 'root',
  timeout: null,
  storage: storageLocal,
  whitelist: ['menu'],
  blacklist: []
};
const persistedReducers = persistReducer(persistConfig, rootReducer);

const Store = createStore(persistedReducers, enhancers);

export default Store;

export const persistor = persistStore(Store);
